export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=704a61145900f7802b632101d59f0e0525c2ab866d&name=pushAdClickData!'